import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const activeCampaign = defineConnector({
  identifier: "activeCampaign",
  name: "ActiveCampaign",
  tagLine: "Email marketing and automation platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://.*\\.api-us1\\.com/api/.*",
  auth: (app) => headerAuth([{ name: "Api-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key and account name",
      items: [
        {
          kind: "markdown",
          content:
            "In [ActiveCampaign](https://www.activecampaign.com/), go to **Settings → Developer** to find your API URL and API key. Your account name is the subdomain in your API URL (e.g., `yourname` from `https://yourname.api-us1.com`).",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Account name",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText: "The subdomain from your ActiveCampaign API URL.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/3/users`,
  },
  publicEnvVars: ({ domain }) => ({
    ACTIVE_CAMPAIGN_URL: domain ? `https://${domain}` : "",
  }),
});
